import React from "react";

/**
 * One icon family for the whole site: 1.6px stroke, round caps, 24px box.
 * Previously each page redeclared its own ArrowUpRight at a different weight.
 */
const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

export const ArrowUpRight = ({ className = "h-4 w-4" }) => (
  <svg {...base} className={className}>
    <path d="M7 17 17 7M9 7h8v8" />
  </svg>
);

export const ArrowRight = ({ className = "h-4 w-4" }) => (
  <svg {...base} className={className}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const ArrowLeft = ({ className = "h-4 w-4" }) => (
  <svg {...base} className={className}>
    <path d="M19 12H5M11 6l-6 6 6 6" />
  </svg>
);

export const Menu = ({ className = "h-5 w-5" }) => (
  <svg {...base} className={className}>
    <path d="M3 6h18M3 12h18M3 18h18" />
  </svg>
);

export const Close = ({ className = "h-5 w-5" }) => (
  <svg {...base} className={className}>
    <path d="M6 6l12 12M18 6 6 18" />
  </svg>
);

export const External = ({ className = "h-4 w-4" }) => (
  <svg {...base} className={className}>
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14 21 3" />
  </svg>
);

export const Download = ({ className = "h-4 w-4" }) => (
  <svg {...base} className={className}>
    <path d="M12 3v12M7 11l5 5 5-5M4 21h16" />
  </svg>
);

export const Refresh = ({ className = "h-4 w-4" }) => (
  <svg {...base} className={className}>
    <path d="M21 12a9 9 0 1 1-2.64-6.36M21 4v5h-5" />
  </svg>
);

export const GooglePlay = ({ className = "h-4 w-4" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    className={className}
  >
    <path d="M3.609 1.814L13.793 12 3.61 22.186c-.378-.344-.61-.84-.61-1.396V3.21c0-.556.232-1.052.61-1.396zm1.48-1.077l10.143 5.856-2.52 2.52L5.09.737zm0 22.526l7.62-7.62 2.52 2.52-10.14 5.856v-.001zm11.378-7.067l2.87-1.657c1.196-.69 1.196-1.819 0-2.51l-2.87-1.657-2.73 2.73 2.73 2.73z" />
  </svg>
);

